import {
  ComparePricingContextItem,
  CompareResults,
} from "../../../queries/useBuildComparison";

export const selectPricingContext = (
  price: CompareResults["partQuantity"]
): Partial<ComparePricingContextItem> & { quantity: number } => {
  const item = Object.values(price).find(Boolean);
  const context = item?.contextList.find(Boolean);
  return { ...context, quantity: Number(item?.quantity) };
};
